import { useState, useEffect, useCallback } from 'react';

/**
 * Sincroniza relógio com APIs públicas (fuso America/Sao_Paulo) para datas de experiência/aniversário.
 */
export function useNetworkTime() {
  const [timeOffset, setTimeOffset] = useState(0);
  const [isTimeSynced, setIsTimeSynced] = useState(false);

  useEffect(() => {
    const syncTime = async () => {
      const timeSources = [
        'https://timeapi.io/api/Time/current/zone?timeZone=America/Sao_Paulo',
        'https://worldtimeapi.org/api/timezone/America/Sao_Paulo',
        `https://api.allorigins.win/raw?url=${encodeURIComponent('https://worldtimeapi.org/api/timezone/America/Sao_Paulo')}`,
      ];

      for (const source of timeSources) {
        try {
          const start = Date.now();
          const response = await fetch(source, { signal: AbortSignal.timeout(3000) });
          if (response.ok) {
            const data = await response.json();
            const rawTime = data.dateTime || data.datetime;
            if (rawTime) {
              const networkTime = new Date(rawTime).getTime();
              const localTime = Date.now();
              const latency = localTime - start;
              setTimeOffset(networkTime - localTime + latency / 2);
              setIsTimeSynced(true);
              return;
            }
          }
        } catch {
          // tenta próxima fonte
        }
      }
      setIsTimeSynced(false);
    };

    void syncTime();
    const interval = setInterval(syncTime, 300000);
    return () => clearInterval(interval);
  }, []);

  const getVerifiedDate = useCallback(() => {
    return new Date(Date.now() + timeOffset);
  }, [timeOffset]);

  return { timeOffset, isTimeSynced, getVerifiedDate };
}
